const checkPhoenixLocation = (str, zipCodes) => {
  return zipCodes.includes(str);
};

export default checkPhoenixLocation;
